import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Button } from 'reactstrap';

import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import moment from 'moment-timezone';

import { surveyApi } from "../../reducers/surveySlice";
import ResponsePopup from "../response/ResponsePopup";

const SurveyListItem = ({survey}) => {
    const [deleting, setDeleting] = useState(false);
    const [closing, setClosing] = useState(false);
    const [showResponsePopup, setShowResponsePopup] = useState(false);

    const dispatch = useDispatch();

    const showDeleteConfirm = (survey) => {
        confirmAlert({
        //   title: 'Confirm to submit',
          message: "Are you sure to DELETE \""+survey.name+"\" ?",
          buttons: [
            {
              label: 'Yes',
                onClick: () => { 
                    setDeleting(true)
                    dispatch( surveyApi.delete(survey) )
                }
            },
            {
                label: 'No',
                onClick: () => {}
            }
          ]
        });
    }

    const showCloseSurveyConfirm = (survey) => {
        confirmAlert({
        //   title: 'Confirm to submit',
          message: "Are you sure to force survey \""+survey.name+"\" to CLOSE?",
          buttons: [
            {
              label: 'Yes',
                onClick: () => { 
                    setClosing(true)
                    dispatch( surveyApi.update({...survey, closed_at: moment().toISOString() }) )
                }
            },
            {
                label: 'No',
                onClick: () => {}
            }
          ]
        });
    }
    
    const getUserCanoncial = (user) => {
        let canonical = `${user.first_name} ${user.last_name}`.trim()
        return canonical.length > 0 ? canonical : user.email
    }

    const formatDate = (dateString) => {
        let desiredFormat = "YYYY-MM-DD HH:mm:ss";
        let timeToBeConverted = moment(dateString, desiredFormat);
        let timeZone = "Europe/Rome";

        return dateString ? timeToBeConverted.tz(timeZone).format(desiredFormat) : <span className="text-light">in sospeso</span>;
    }

    const getAlertClassName = (score) => {
        let className = "alert "

        if(score == 0) className += "alert-light"
        else if(score == 1) className += "alert-danger"
        else if(score > 1 && score <= 2) className += "alert-warning"
        else if(score > 2 && score <= 3) className += "alert-success"
        
        return className
    }

    const scoreStyle = {
        width: '60px', display: 'block', textAlign: 'center'
    }

    return (
        <>
            <tr onClick={() => { setShowResponsePopup(true) }} style={{cursor: 'pointer'}}>
                <td style={{ width: "1%" }} >{survey.id}</td>
                <td style={{ width: "18%", whiteSpace: 'nowrap' }} ><b>{survey.name}</b></td>
                <td style={{ width: "18%", whiteSpace: 'nowrap' }} >{survey.user ? getUserCanoncial(survey.user) : "-"}</td>
                <td style={{ width: "18%", whiteSpace: 'nowrap' }} >{ formatDate(survey.created_at) }</td>
                <td style={{ width: "18%", whiteSpace: 'nowrap' }} >{ formatDate(survey.updated_at) }</td>
                <td style={{ width: "18%", whiteSpace: 'nowrap' }} >{ formatDate(survey.closed_at) }</td>
                <td style={{ width: "2%", whiteSpace: 'nowrap' }} ><span className={getAlertClassName(survey.avg_score)} style={scoreStyle}>{parseFloat(survey.avg_score.toFixed(2))}</span></td>
                
                <td style={{ width: "10%", whiteSpace: "nowrap" }} >
                    <Button onClick={(e) => { showDeleteConfirm(survey); e.stopPropagation(); }} className="btn btn-danger " disabled={deleting} > <i className="fas fa-trash-alt" /> </Button>
                    {
                        survey && survey.closed_at === null 
                        ? <Button onClick={(e) => { showCloseSurveyConfirm(survey); e.stopPropagation(); }} className="ml-1 btn btn-success " disabled={closing} > <i className="fas fa-check" /> </Button>
                        : <></>
                    }
                </td>
            </tr>
            { 
                showResponsePopup
                    ? <ResponsePopup survey={survey} onToggle={() => { setShowResponsePopup(false) }} />
                    : null
            }
        </>
    )
}

export default SurveyListItem;

